(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-collections"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carouselContainer = document.getElementById("carousel-products");

    if (!carouselContainer) return;

    const swiperEl = carouselContainer.querySelector('.carousel-swiper');

    if (swiperEl && typeof Swiper !== 'undefined') {
      const swiper = new Swiper(swiperEl, {
        slidesPerView: 1.5,
        spaceBetween: 20,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        },
        breakpoints: {
          750: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        }
      });

      const prevBtn = carouselContainer.querySelector(".carousel__prev");
      const nextBtn = carouselContainer.querySelector(".carousel__next");

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          swiper.slidePrev();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          swiper.slideNext();
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
      const swiperContainers = document.querySelectorAll(".collections-products__swiper");

      swiperContainers.forEach((container) => {
        const swiperEl = container.querySelector(".swiper");

        if (swiperEl) {
          const swiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            breakpoints: {
              750: {
                slidesPerView: 3.5,
                spaceBetween: 20,
              }
            }
          });

          const prevBtn = container.querySelector(".carousel__prev");
          const nextBtn = container.querySelector(".carousel__next");

          if (prevBtn) {
            prevBtn.addEventListener("click", () => swiper.slidePrev());
          }

          if (nextBtn) {
            nextBtn.addEventListener("click", () => swiper.slideNext());
          }
        }
      });
    }
  })

  } catch(e) { console.error(e); }
})();
})();
